import {Box, Card, CardHeader, Container, IconButton,Link, Avatar, Stack, Typography, Grid} from '@mui/material';
import Page from '../components/Page';
import { useEffect, useState } from 'react';
import api from '../api';
import backIcon from '@iconify/icons-ant-design/arrow-left-outline';
import { Icon } from '@iconify/react';
import { useNavigate,Link as RouterLink } from "react-router-dom";
import Pagination from '@mui/material/Pagination';

export default function LeaderBoard() {
  const [data, setData] = useState({});
  const [page, setPage] = useState(1);
  let navigate = useNavigate();

  useEffect(() => {
    loadData();

  },[]);

  useEffect(() => {
    loadData();
  },[page]);

  const loadData = () => {
    api.get('/leaderboard?page='+page).then(function(response) { return response; })
        .then(function(resultData) {
          if (resultData.success){
            setData(resultData.data);
          }
        });
  }
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
      <Page title="Leaderboard view | eagles.uz">
        <Container>
          <IconButton aria-label="fingerprint" color="success"  onClick={() => navigate(-1)}>
            <Icon icon={backIcon} width={24} height={24}/>
          </IconButton>
          <Card sx={{mt:3}}>
            <CardHeader title={ "Leaderboard for "+data.period } />
            <Box sx={{ p: { xs: 1, sm: 3 }, pb: 1 }} dir="ltr">
              <Stack spacing={2}>
                <Stack direction="row" sx={{ px: 2, py: 1, bgcolor: 'background.neutral', borderRadius: 1, display: { xs: 'none', md: 'flex' } }}>
                   <Box sx={{ width: 40, textAlign: 'center' }}>№</Box>
                   <Box sx={{ flexGrow: 1, ml: 2 }}>Name</Box>
                   <Box sx={{ width: 80, textAlign: 'right' }}>Points</Box>
                   <Box sx={{ width: 100, textAlign: 'right' }}>Active days</Box>
                </Stack>
             
                {data?.data?.map((row) => (
                   <Stack 
                     key={row.name} 
                     direction="row" 
                     alignItems="center" 
                     sx={{ 
                       p: 2, 
                       borderRadius: 1,
                       bgcolor: api.getUserId() == row.user_id ? 'action.selected' : 'background.paper',
                       boxShadow: { xs: 1, md: 0 },
                       mb: { xs: 1, md: 0 }
                     }}
                   >
                      <Box sx={{ width: { xs: 30, md: 40 }, textAlign: 'center', fontWeight: 'bold' }}>{row.rn}</Box>
                      
                      <Box sx={{ flexGrow: 1, ml: 2, display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                         <Avatar 
                            src={"https://files.eagles.uz/"+row.user_avatar} 
                            alt={row.user_full_name}
                            sx={{ width: { xs: 32, md: 40 }, height: { xs: 32, md: 40 }, mr: 1.5 }}
                         />
                         <Box sx={{ minWidth: 0 }}>
                           <Link component={RouterLink} to={`/dashboard/home/${row.user_id}`} underline="hover">
                              <Typography variant="subtitle2" noWrap>
                                 {row.user_full_name}
                              </Typography>
                           </Link>
                          
                           <Typography variant="caption" sx={{ display: { xs: 'block', md: 'none' }, color: 'text.secondary' }}>
                             {row.user_active_days} active days
                           </Typography>
                           <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 'bold',display: { xs: 'block', md: 'none' } }}>{row.total_sum}</Typography>
                         </Box>
                      </Box>
            
                      <Box sx={{ textAlign: 'right', ml: 1, minWidth: 60, flexShrink: 0 }}>
                         <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 'bold', display: { xs: 'none', md: 'block' } }}>{row.total_sum}</Typography>
                      </Box>
            
                      <Box sx={{ width: 100, textAlign: 'right', display: { xs: 'none', md: 'block' } }}>
                         {row.user_active_days}
                      </Box>
                   </Stack>
                ))}
              </Stack>
              <Pagination count={data.last_page} page={page} onChange={handleChangePage} color="primary" variant="outlined" shape="rounded" sx={{ mt: 2, display: 'flex', justifyContent: 'center' }} />
            </Box>
          </Card>


        </Container>
      </Page>
  );
}